module.exports = __webpack_public_path__ + "static/media/mw.bfd6db10.svg";